import { render } from "./salary.vue?vue&type=template&id=369ba6d3"
import script from "./salary.vue?vue&type=script&lang=js"
export * from "./salary.vue?vue&type=script&lang=js"

import exportComponent from "/Users/qiao/KaungSpace/DevSpace/KaungAdmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__